import { useEffect } from "react";
import { useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../app/hooks";
import { selectSelectedPnsIds } from "../DesignTab/routing/pnsSelectionSlice";

export const usePnsQuerySync = () => {
  const [, setSearchParams] = useSearchParams();
  const selectedPnsIds = useAppSelector(selectSelectedPnsIds);
  const didMountRef = useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    const nextValue = selectedPnsIds.join(",");

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        const current = next.get("pns") ?? "";

        if (!nextValue) {
          if (!next.has("pns")) return prev;
          next.delete("pns");
          return next;
        }

        if (current === nextValue) return prev;

        next.set("pns", nextValue);
        return next;
      },
      { replace: true }
    );
  }, [selectedPnsIds, setSearchParams]);
};
